import { useLocation } from 'react-router-dom';
import Store from '../Store';

export const ROLE_CLAIM_KEY =
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';

export function getRawPermissions(): string[] {
  const state: any = Store.getState();
  const authRole = state.auth?.[ROLE_CLAIM_KEY];
  if (Array.isArray(authRole)) {
    return authRole;
  }
  if (typeof authRole === 'string') {
    return [authRole];
  }
  return [];
}

/**
 * Maps a URL route path to the corresponding permission module prefix(es).
 */
export function getModuleCodesForPath(path: string): string[] {
  if (!path || path === '/') {
    return [
      'dashboard',
      'dashboard.dosd',
      'dashboard.elearning',
      'dashboard.trainer',
    ];
  }

  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  if (cleanPath === 'role/permission') {
    return ['sec.rol'];
  }
  if (cleanPath === 'role/user') {
    return ['sec.use'];
  }

  return [cleanPath.replace(/\//g, '.')];
}

/**
 * Dynamic permission check hook for UI components and menus.
 */
export default function HasPermission(
  ability: string,
  path: string | null = null,
): boolean {
  const location = useLocation();

  const basePathFromLocation =
    (process.env.REACT_APP_PUBLIC_URL
      ? location.pathname.replace(process.env.REACT_APP_PUBLIC_URL, '')
      : location.pathname) || '/';
  const currentPath = path === null ? basePathFromLocation : path;

  const rawPermissions = getRawPermissions();
  if (!rawPermissions.length) return false;

  const moduleCodes = getModuleCodesForPath(currentPath);

  for (const moduleCode of moduleCodes) {
    const permissionKey = `${moduleCode}.${ability}`;
    if (rawPermissions.includes(permissionKey)) {
      return true;
    }
  }

  return false;
}
